import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c658738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-screen h-screen absolute" }
const _hoisted_2 = { class: "h-screen flex items-center justify-center" }
const _hoisted_3 = { class: "experienceModal fixed mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-between h-full"
}
const _hoisted_5 = { class: "monitorHolder h-full relative" }
const _hoisted_6 = { class: "w-full h-full flex justify-center items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "rightSide" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "setting font-medium" }
const _hoisted_13 = { class: "flex justify-start flex-wrap" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "overview font-bold mt-6" }, " OVERVIEW ", -1))
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "contributions font-bold mt-6"
}
const _hoisted_18 = { class: "contributionsBox font-normal" }
const _hoisted_19 = { class: "contributionsList" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "skills font-bold mt-6" }, " SKILLS ", -1))
const _hoisted_22 = { class: "skillsBox font-normal" }
const _hoisted_23 = {
  key: 1,
  class: "h-full"
}
const _hoisted_24 = { class: "monitorHolder w-full relative" }
const _hoisted_25 = { class: "w-full h-full flex justify-center items-center" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "rightSide h-full relative" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "setting font-medium" }
const _hoisted_32 = { class: "flex justify-start flex-wrap" }
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "overview font-bold mt-6" }, " OVERVIEW ", -1))
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 0,
  class: "contributions font-bold mt-6"
}
const _hoisted_37 = { class: "contributionsBox font-normal" }
const _hoisted_38 = { class: "contributionsList" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "skills font-bold mt-6" }, " SKILLS ", -1))
const _hoisted_41 = { class: "skillsBox font-normal pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalMiniBox = _resolveComponent("ModalMiniBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
      class: "shadow bg-black w-screen h-screen z-50 absolute left-0 top-0 opacity-90"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.screen == 'computer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                  class: "exit font-light absolute top-6 right-6"
                }, " x "),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      class: "monitor",
                      src: _ctx.info.screen,
                      style: _normalizeStyle({ width: _ctx.monitorWidth })
                    }, null, 12, _hoisted_7)
                  ]),
                  _createElementVNode("img", {
                    class: "back h-full absolute object-cover top-0 left-0",
                    src: _ctx.info.background
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", {
                    class: "role font-bold",
                    innerHTML: _ctx.info.title
                  }, null, 8, _hoisted_10),
                  _createElementVNode("p", {
                    class: "company font-semibold",
                    innerHTML: _ctx.info.company
                  }, null, 8, _hoisted_11),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.info.location) + "   |   " + _toDisplayString(_ctx.info.time), 1),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "btn link font-medium text-black flex justify-center items-center"
                        }, _toDisplayString(link.title), 9, _hoisted_14)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_15,
                  _createElementVNode("p", {
                    class: "desc font-normal",
                    innerHTML: _ctx.info.description
                  }, null, 8, _hoisted_16),
                  (_ctx.info.contributions.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, " CONTRIBUTIONS "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("ul", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.contributions, (contribution) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: contribution }, null, 8, _hoisted_20))
                      }), 256))
                    ])
                  ]),
                  _hoisted_21,
                  _createElementVNode("p", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.skills, (skill) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createVNode(_component_ModalMiniBox, {
                          info: skill,
                          type: "skillsBox"
                        }, null, 8, ["info"])
                      ]))
                    }), 256))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("img", {
                      class: "monitor",
                      src: _ctx.info.screen,
                      style: _normalizeStyle({ width: _ctx.monitorWidth, maxWidth: _ctx.monitorMaxWidth })
                    }, null, 12, _hoisted_26)
                  ]),
                  _createElementVNode("img", {
                    class: "back h-full w-full absolute object-cover top-0 left-0",
                    src: _ctx.info.background
                  }, null, 8, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                    class: "exit font-light absolute top-4 right-3"
                  }, " x "),
                  _createElementVNode("p", {
                    class: "role font-bold",
                    innerHTML: _ctx.info.title
                  }, null, 8, _hoisted_29),
                  _createElementVNode("p", {
                    class: "company font-semibold",
                    innerHTML: _ctx.info.company
                  }, null, 8, _hoisted_30),
                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.info.location) + "   |   " + _toDisplayString(_ctx.info.time), 1),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("a", {
                          href: link.url,
                          target: "_blank",
                          class: "btn link font-medium text-black flex justify-center items-center"
                        }, _toDisplayString(link.title), 9, _hoisted_33)
                      ]))
                    }), 256))
                  ]),
                  _hoisted_34,
                  _createElementVNode("p", {
                    class: "desc font-normal",
                    innerHTML: _ctx.info.description
                  }, null, 8, _hoisted_35),
                  (_ctx.info.contributions.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, " CONTRIBUTIONS "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("ul", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.contributions, (contribution) => {
                        return (_openBlock(), _createElementBlock("li", { innerHTML: contribution }, null, 8, _hoisted_39))
                      }), 256))
                    ])
                  ]),
                  _hoisted_40,
                  _createElementVNode("p", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.skills, (skill) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createVNode(_component_ModalMiniBox, {
                          info: skill,
                          type: "skillsBox"
                        }, null, 8, ["info"])
                      ]))
                    }), 256))
                  ])
                ])
              ]))
        ])
      ])
    ])
  ], 64))
}